// Load product grid
function initializeProductGrid() {
  const products = document.querySelectorAll('.product-item');
  const loadMoreButton = document.getElementById('load-more');

  if (!loadMoreButton) return;

  const itemsToShow = 6;
  let currentIndex = 0;

  function showItems() {
    for (let i = currentIndex; i < currentIndex + itemsToShow; i++) {
      if (products[i]) {
        products[i].style.display = 'block';
      }
    }

    currentIndex += itemsToShow;

    if (currentIndex >= products.length) {
      loadMoreButton.style.display = 'none';
    } else {
      loadMoreButton.style.display = 'block';
    }
  }

  function resetPagination() {
    currentIndex = 0;
    products.forEach((product, index) => {
      if (index >= itemsToShow) {
        product.style.display = 'none';
      } else {
        product.style.display = 'block';
      }
    });
    currentIndex += itemsToShow;

    if (currentIndex >= products.length) {
      loadMoreButton.style.display = 'none';
    } else {
      loadMoreButton.style.display = 'block';
    }
  }

  resetPagination();

  loadMoreButton.addEventListener('click', showItems);
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initializeProductGrid, 1000);
});